import { Box,Typography } from '@mui/material'
import React from 'react'
import BankCard from '../../Components/UI/BankCard'

export default function BankService() {
  //https://www.sonalibank.com.bd/
  //https://www.jb.com.bd/
  return (
    <Box sx={{width:"100vw",minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",margin:{md:"7vh"}}}>
        <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"15vh",marginTop:{xs:"3vh",md:"7vh"},textAlign:"center"}}>
            <Typography variant="h4" color="primary" sx={{maxWidth:"80vw"}}>Astha Banking partners</Typography>
            <Typography variant="p" sx={{maxWidth:"80vw"}}>See all our partners who provide you banking services</Typography>
        </Box>
        <Box sx={{display:"flex" ,width:{xs:"80vw",md:"80vw"},flexDirection:{xs:"column",md:"row"},flexWrap:"wrap",alignItems:"center",justifyContent:"space-around",height:"70vh"}}>
            <a href="https://www.jb.com.bd/" target="_blank" style={{textDecoration:"none"}}><BankCard name="Janata Bank" icon="https://i.postimg.cc/wB7zv8wQ/Janata-Bank.png" color="#0099FF" /></a>
            <a href="https://www.sonalibank.com.bd/" target="_blank" style={{textDecoration:"none"}}><BankCard name="Sonali Bank" icon="https://i.postimg.cc/XY2347kv/Sonali-Bank-Limited-svg.png" color="#DBA627"/></a>
            <a href="https://www.meghnabank.com.bd/" target="_blank" style={{textDecoration:"none"}}><BankCard name="Meghna Bank" icon="https://i.postimg.cc/Qdy8TvWd/Meghna-Bank-Limited.jpg" color="#800080"/></a>
        </Box>
        
    </Box>
  )
}
